import useTalentPicks from "@tvg/talent-picks-desk/src/hooks/useTalentPicks";
import useWagerProfile from "@tvg/custom-hooks/hooks/useWagerProfile";
import { useState, useEffect } from "react";
import { UseGetValidTalentProps } from "../types";

export const useGetValidTalentPick = (props: UseGetValidTalentProps) => {
  const [validTalentPick, setValidTalentPick] = useState(props.talentPick);
  const wagerProfile = useWagerProfile();

  const { talentPicks: picksDesk } = useTalentPicks({
    raceNumber: props.talentPick.race.toString(),
    trackCode: props.talentPick.track,
    wagerProfile,
    skip: !props.onHomePage || !wagerProfile
  });
  useEffect(() => {
    const pickDesk = picksDesk?.talentPicks?.find(
      (talent) => talent.id === props.talentPick.id
    );

    if (pickDesk) {
      setValidTalentPick(pickDesk);
    }
  }, [picksDesk]);

  return validTalentPick;
};
